import React from 'react'
import css from './burger.css'

const Burger = props => {


  const targetClassName = `hamburger hamburger--${props.burger}${ props.active ? " is-active" : "" }`

  return (
    <button
      onClick={props.onClick}
      className={targetClassName}
      type="button"
    >
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </button>
  )
}

export default Burger
